import { createContext, useCallback, useMemo, useReducer } from 'react';

const API_CALL_DEF_STATE = {
  disableRouteChange: false,
};

const API_CALL_ACTION = {
  toggleDisableRouteChange: 'toggleDisableRouteChange',
};

function apiCallReducer(state, action) {
  switch (action.type) {
    case API_CALL_ACTION.toggleDisableRouteChange: {
      const disableRouteChange =
        typeof action.data !== 'undefined'
          ? action.data
          : !state.disableRouteChange;
      if (disableRouteChange === state.disableRouteChange) {
        return state;
      }
      return {
        ...state,
        disableRouteChange,
      };
    }
    default:
      return state;
  }
}

export const ApiCallContext = createContext();
export const ApiCallContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(apiCallReducer, API_CALL_DEF_STATE);
  const toggleDisableRouteChange = useCallback((overrideVal) => {
    dispatch({
      type: API_CALL_ACTION.toggleDisableRouteChange,
      data: overrideVal,
    });
  }, []);

  const value = useMemo(
    () => ({ ...state, toggleDisableRouteChange }),
    [state, toggleDisableRouteChange],
  );

  return (
    <ApiCallContext.Provider value={value}>
      {children}
    </ApiCallContext.Provider>
  );
};
